import React from 'react';
import { Row, Col } from 'react-bootstrap';
import moment from 'moment';

// Services
import API from 'API';
import FormHelper from 'helpers/FormHelper';

// Components
import SuperTable from 'components/common/SuperTable';
import Loader from 'components/common/Loader';
import EditAccountInvoiceModal from 'components/head-office/EditAccountInvoiceModal';

//-----------------------------------------------------------------

class AccountInvoices extends React.Component {

    constructor(props) {
        super(props);

        this.editAccountInvoiceModalRef = React.createRef();

        this.state = {
            isLoading: true,
            isLoadingFilters: true,
            accountInvoices: [],
            filters: {
                accountID: null,
                dateFrom: null,
                dateTo: null
            }
        };

        this.filtersForm = new FormHelper({
            fields: {
                accountID: {
                    label: 'Area',
                    type: 'single-select',
                    blankText: '(All)',
                    getOptions: () => this.state.accounts.map(a => ({
                        value: a.id,
                        text: a.name
                    }))
                },
                dateFrom: {
                    label: 'Date (from)',
                    type: 'date'
                },
                dateTo: {
                    label: 'Date (to)',
                    type: 'date'
                }
            },
            getValue: (fieldName) => this.state.filters[fieldName],
            setValue: (fieldName, value) => this.updateFilters({ [fieldName]: value })
        });
    }

    componentDidMount() {
        this.props.fns.setTitle('Invoices');
        this.load();
        this.loadFilters();
    }

    async loadFilters() {
        this.setState({ isLoadingFilters: true });
        let accounts = await API.call('head-office/list-accounts');
        accounts = accounts.filter(a => !a.isHeadOffice && !a.isBookingAgent);
        this.setState({
            isLoadingFilters: false,
            accounts
        });
    }

    updateFilters(newValues) {
        const filters = { ...this.state.filters };
        let isChanged = false;
        for (let fieldName in newValues) {
            let value = newValues[fieldName];
            switch (fieldName) {
                case 'dateFrom':
                case 'dateTo':
                    value = moment(value).format('YYYY-MM-DD');
                    break;
            }
            if (value != filters[fieldName]) {
                filters[fieldName] = value;
                isChanged = true;
            }
        }
        this.setState({
            filters,
            isLoading: isChanged
        }, () => {
            if (isChanged) {
                this.load();
            }
        });
    }
    
    async load() {
        this.setState({ isLoading: true });
        
        // Load and update
        const accountInvoices = await API.call('account-invoice/list', this.state.filters);
        this.setState({
            isLoading: false,
            accountInvoices
        });
    }

    async add() {
        const { loginInfo } = this.props;
        await this.editAccountInvoiceModalRef.current.open({
            accountID: loginInfo.accountID
        });
        this.load();
    }

    async open(id) {
        await this.editAccountInvoiceModalRef.current.open({
            id
        });
        this.load();
    }

    async generateAllDue() {
        this.setState({ isLoading: true });
        await API.call('account-invoice/generate-all-due');
        this.load();
    }

    //----------------------------------------------------------------------

    render() {
        return (<>
            <section className="control-panel sticky">

                <h1>Invoices</h1>

                <div className="control-panel-component ms-auto">
                    <button type="button" className="btn btn-primary me-3" onClick={() => this.generateAllDue()}>
                        Create Monthly Invoices
                    </button>

                    <button type="button" className="btn btn-secondary" onClick={() => this.add()}>
                        Add Invoice Manually
                    </button>
                </div>

            </section>

            <Row>

                <Col md="3">

                    <section>

                        {this.renderFilters()}

                    </section>

                </Col>

                <Col md="9">

                    <section>

                        {this.renderTable()}

                    </section>

                </Col>

            </Row>


            {/*
            <EditAccountModal
                ref={this.editAccountModalRef}
                {...this.props}
            />
            */}
            <EditAccountInvoiceModal
                ref={this.editAccountInvoiceModalRef}
            />
            
        </>);
    }

    renderFilters() {
        const { isLoadingFilters } = this.state;
        if (isLoadingFilters) {
            return (<Loader />);
        }
        return this.filtersForm.render([
            'accountID',
            'dateFrom',
            'dateTo'
        ]);
    }

    renderTable() {
        const {
            isLoading,
            accountInvoices
        } = this.state;

        if (isLoading) {
            return (<Loader />);
        }
        
        const cols = {
            number: {
                label: 'Number'
            },
            accountName: {
                label: 'Franchisee'
            },
            dateIssued: {
                label: 'Date Issued',
                type: 'date'
            },
            dateDue: {
                label: 'Date Due',
                type: 'date'
            },
            totalNet: {
                label: 'Total (Net)',
                type: 'currency'
            }
        };

        return (
            <SuperTable
                className="account-invoices-table table table-bordered clickable mb-0"
                rows={accountInvoices}
                keyAccessor={accountInvoice => accountInvoice.id}
                cols={cols}
                onClick={(accountInvoice, e) => this.open(accountInvoice.id)}
                emptyText="No invoices to show"
            />
        );
    }
}

export default AccountInvoices;